export const GET_STARTED = '/get-started';
export const GET_STARTED_STEPS = {
  USERNAME: 'username',
  NAMES: 'names',
}

export const USERS = '/users';
export const USERS_STEPS = {
  LOGIN: 'login',
  CREATE: 'create',
  UPDATE_CREDENTIALS: 'update-credentials',
  UPDATE_USER: 'update-user',
  RESET_PASSWORD: 'reset-password',
  REQUEST_ACCESS: 'request-access',
  PRACTITIONER_VIEW: 'practitioner-view',
  CREATE_CLIENT: 'create-client',
  UPDATE_CLIENT: 'update-client',
  REVIEW: 'review'
}

export const STATIC = '/static';
export const STATIC_PAGES = {
  ABOUT: 'about',
  RESOURCES: 'resources',
  PRIVACY: 'privacy'
}
export const ABOUT_URL = STATIC + "/" + STATIC_PAGES.ABOUT; 
export const RESOURCES_URL = STATIC + "/" + STATIC_PAGES.RESOURCES; 
export const PRIVACY_URL = STATIC + "/" + STATIC_PAGES.PRIVACY; 

export const EVAL_INTRO = '/eval-intro';

export const TABS = {
  GATHER: '/gather-info',
  EVAL: '/evaluate-abilities',
  TEST: '/test-drive',
  REVIEW: '/review'
};

export const SUBTABS = {
  GATHER_INTRO: [TABS.GATHER]+'/intro',
  GOALS: [TABS.GATHER]+'/goals',
  CONTEXTS: [TABS.GATHER]+'/contexts',
  HISTORY: [TABS.GATHER]+'/history',
  GATHER_REVIEW: [TABS.GATHER]+'/review',
  EVAL_INTRO: [TABS.EVAL]+'/intro',
  PHYSICAL: [TABS.EVAL]+'/physical',
  VISUAL: [TABS.EVAL]+'/visual',
  COGNITION: [TABS.EVAL]+'/language-cognition',
  OTHER: [TABS.EVAL]+'/other',
  EVAL_REVIEW: [TABS.EVAL]+'/review',
  TEST_INTRO: [TABS.TEST]+'/intro',
  CHOOSE: [TABS.TEST]+'/choose',
  SETUP: [TABS.TEST]+'/setup',
  TRY: [TABS.TEST]+'/try',
  RATE: [TABS.TEST]+'/rate',
  INTERPRET: [TABS.TEST]+'/interpret',
  TEST_REVIEW: [TABS.TEST]+'/review',
  REVIEW_INTRO: [TABS.REVIEW]+'/intro',
  COMPARE: [TABS.REVIEW]+'/compare',
  MAKE_CHOICES: [TABS.REVIEW]+'/make-choices',
  NEXT_STEPS: [TABS.REVIEW]+'/next-steps' 
}

export const GOALS_STEPS = {
  INTRO: 'intro',
  MAIN: 'main',
  ACTIVITIES: 'activities',
  PRIORITY: 'priority',
  PLATFORMS: 'platforms',
  REVIEW: 'review'
}
export const CONTEXTS_STEPS = {
  INTRO: 'intro',
  ENVIRONMENTS: 'environments',
  POSITIONS: 'positions',
  INDEPENDENCE: 'independence',
  REVIEW: 'review'
}
//TODO OK that 'platforms' is also used in the GOALS section?
export const HISTORY_STEPS = {
  INTRO: 'intro',
  CURRENT: 'current',
  CURRENT_METHODS: 'current-methods',
  PAST_METHODS: 'past-methods',
  PLATFORMS: 'platforms',
  REVIEW: 'review'
}

export const PHYSICAL_STEPS = {
  BASIC: 'basic',
  INDEPTH: 'indepth'
}
export const VISUAL_STEPS = {
  INTRO: 'intro',
  BACKGROUND: 'background',
  ISSUES: 'issues',
  WRAPUP: 'wrapup'
}
export const COGNITION_STEPS = {
  FEATURES: 'features',
}
export const OTHER_STEPS = {
  CHARACTERISTICS: 'characteristics',
}

export const CHOOSE_STEPS = {
  FIRST: 'first',
  ACCESS_METHOD: 'access-method'
}
export const SETUP_STEPS = {
  INTRO: 'intro',
  SELECTION_METHOD: 'selection-method',
  BODY_SITES: 'body-sites',
  ACCESSORIES: 'accessories',
  INFO: 'info',
  NAME: 'name',
  SANDBOX: 'sandbox',
  REVIEW: 'review'
}
export const TRY_STEPS = {
  ACTIVITY: 'activity',
  START: 'start',
  DO: 'do',
  UPDATE: 'update-setup',
  ANOTHER: 'another-activity'
}
export const RATE_STEPS = {
  CLIENT: 'client',
  PRACTITIONER: 'practitioner',
  ISSUES: 'issues',
  REVIEW: 'review',
}
export const INTERPRET_STEPS = {
  DEEPER: 'deeper',
  CHOOSE: 'choose',
}
export const MAKE_CHOICES_STEPS = {
  INTRO: 'intro',
  PICKS: 'picks',
  CHECKLIST: 'checklist'
}
export const NEXT_STEPS_STEPS = {
  PICKS: 'picks',
  GEN_REPORT: 'generate-report',
  REPORT: 'report'
}

